import React from 'react';

import { Button } from 'components/DesignSystem/Button';
import classes from 'components/Settings/Components/UsersManagement/components/usersManagement.module.scss';

export const UsersManagementTitle = ({ addUserCallback, availableUsers, maxUsersNumber, className }) => {
    const isUsersAvailable = availableUsers > 0;

    return (
        <div className={className}>
            <Button size={'medium'} variant={'primary'} disabled={!isUsersAvailable} onClick={addUserCallback}>
                Add User
            </Button>

            <div className={classes.availableUsersContainer}>
                (<span className={`${!isUsersAvailable ? classes.risk : ''}`}>{availableUsers}</span> available users
                out of {maxUsersNumber})
            </div>
        </div>
    );
};
